export const EPdlErrorType = {
  PDL_UNAVAILABLE: 'PDL_UNAVAILABLE',
  PDL_NOT_FOUND: 'PDL_NOT_FOUND',
  CONTRACT_NUMBER_MANDATORY: 'CONTRACT_NUMBER_MANDATORY',
} as const;

export const EPromotionCodeErrorType = {
  PROMOTION_CODE_INVALID: 'PROMOTION_CODE_INVALID',
} as const;

export const EDirectDebitErrorType = {
  BUDGET_BREAKDOWN_NOT_GENERATED: 'BUDGET_BREAKDOWN_NOT_GENERATED',
  MY_BATTERY_OPTION_NOT_COMPATIBLE_WITH_REALTIME_DIRECT_DEBIT_MODE:
    'MY_BATTERY_OPTION_NOT_COMPATIBLE_WITH_REALTIME_DIRECT_DEBIT_MODE',
  INVALID_LINEAR_MONTHLY_PAYMENT: 'INVALID_LINEAR_MONTHLY_PAYMENT',
} as const;
